import template from './prefix-table.html';
import controller from './prefix-table.controller';

let PrefixTableComponent = {
  bindings: {
    prefixes: '=',
    modelValue: '='
  },
  template,
  controller
};

export default PrefixTableComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/common/prefix-table/prefix-table.component.js